import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import ReplayIcon from "@mui/icons-material/Replay";
import IosShareIcon from "@mui/icons-material/IosShare";
import { CopyToClipboard } from "react-copy-to-clipboard";
import { Snackbar, Alert } from "@mui/material";
import circle from "../../../assets/circle.svg";
import { motion } from "framer-motion";
import ResultModal from "../Result/Modal/Modal";
import EndModal from "../Result/Modal/EndModal";
import styled from "styled-components";

const Result = () => {
  const [modalShow, setModalShow] = useState(false);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [downloadModal, setDownloadModal] = useState(false);
  const [pointModal, setPointModal] = useState(false);

  const navigate = useNavigate();

  const location = useLocation();
  const userInfo = location.state.userInfo;
  const name = userInfo.name;
  const studentCode = userInfo.studentCode;
  // const resultScore = location.state.resultScore;
  const resultScore = location.state.quizresult;
  const goMain = () => {
    navigate("/eventOldQuiz/main");
  };

  const totalScore = resultScore => {
    const totalResults = [];

    resultScore?.map(item =>
      totalResults.push(item.choice_id === item.answer_id)
    );

    let count = 0;
    totalResults.map(el => {
      if (el) {
        count++;
      }
      return count;
    });
    return count;
  };

  const totalCount = totalScore(resultScore);
  const COUNT = TOTAL_RESULTS.find(item => item.count === totalCount);

  const handleSnackbar = () => {
    setOpenSnackbar(current => !current);
  };

  const drawResult = {
    hidden: { pathLength: 0, opacity: 0 },
    visible: custom => {
      const delay = custom * 0.5;
      return {
        pathLength: 1,
        opacity: 1,
        transition: {
          pathLength: { delay, type: "spring", duration: 1, bounce: 0 },
          opacity: { delay, duration: 0.01 },
        },
      };
    },
  };

  const drawTotalResult = {
    hidden: {
      opacity: 0,
    },
    visible: custom => ({
      opacity: 1,
      transition: {
        delay: custom * 0.5,
        ease: "easeInOut",
      },
    }),
  };

  return (
    <ResultContainer>
      <GradeContainer>
        <GridGrade
          gridColumn="1/6"
          gridRow="1/2"
          backgroundColor="#ececec"
          fontSize="3em"
          letterSpacing="0.5em"
          paddingLeft="0.7em"
          paddingTop="0.1em"
        >
          성적통지표
        </GridGrade>
        <GridGrade
          gridColumn="1/3"
          gridRow="2/3"
          fontSize="1.5em"
          paddingTop="0.2em"
        >
          이 름
        </GridGrade>
        <GridGrade
          gridColumn="3/6"
          gridRow="2/3"
          fontSize="1.5em"
          paddingTop="0.2em"
          color="#6f6f6f"
        >
          {name}
        </GridGrade>
        <GridGrade
          gridColumn="1/3"
          gridRow="3/4"
          fontSize="1.5em"
          paddingTop="0.2em"
        >
          수 험 번 호
        </GridGrade>
        <GridGrade
          gridColumn="3/6"
          gridRow="3/4"
          fontSize="1.5em"
          paddingTop="0.2em"
          color="#6f6f6f"
        >
          {studentCode.slice(0, 4)}-{studentCode.slice(4, 8)}
        </GridGrade>
        {CLASSES.map((item, idx) => (
          <GridGrade
            key={idx}
            gridColumn={Number(idx + 1) + "/" + Number(idx + 2)}
            gridRow="4/5"
            fontSize="1.3em"
            paddingTop="0.2em"
            color="#6f6f6f"
          >
            {item}교시
          </GridGrade>
        ))}
        {resultScore.map((item, idx) => (
          <GridGrade
            key={idx}
            gridColumn={Number(idx + 1) + "/" + Number(idx + 2)}
            gridRow="5/6"
            fontSize="5em"
            color="#f11a26"
            fontFamily="BMYEONSUNG"
          >
            {item.choice_id === item.answer_id ? (
              <motion.svg
                width="65%"
                height="65%"
                viewBox="0 0 100 100"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                initial="hidden"
                animate="visible"
              >
                <motion.circle
                  cx="50"
                  cy="50"
                  r="42.5"
                  stroke="#FF4A41"
                  strokeWidth="15"
                  variants={drawResult}
                  custom={idx}
                />
              </motion.svg>
            ) : (
              <motion.svg
                width="60%"
                height="60%"
                viewBox="0 0 96 96"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                initial="hidden"
                animate="visible"
              >
                <motion.line
                  x1="11.3559"
                  y1="8.23749"
                  x2="87.8916"
                  y2="84.7732"
                  stroke="#FF4A41"
                  strokeWidth="15"
                  strokeLinecap="round"
                  variants={drawResult}
                  custom={idx}
                />
                <motion.line
                  x1="8.60693"
                  y1="84.5357"
                  x2="85.1427"
                  y2="8.00001"
                  stroke="#FF4A41"
                  strokeWidth="15"
                  strokeLinecap="round"
                  variants={drawResult}
                  custom={idx}
                />
              </motion.svg>
            )}
          </GridGrade>
        ))}

        <GridGrade
          gridColumn="1/3"
          gridRow="6/7"
          fontSize="4em"
          fontFamily="BMYEONSUNG"
          color="#F11A26"
          paddingTop="0.1em"
        >
          <CircleImg
            src={circle}
            alt="circle"
            variants={drawTotalResult}
            initial="hidden"
            animate="visible"
            custom={5}
          />
          <TotalResult
            variants={drawTotalResult}
            initial="hidden"
            animate="visible"
            custom={5.5}
          >
            {COUNT?.result}
          </TotalResult>
          <PlusOrMinus
            variants={drawTotalResult}
            initial="hidden"
            animate="visible"
            custom={6}
          >
            +
          </PlusOrMinus>
        </GridGrade>
        <GridGrade
          gridColumn="3/6"
          gridRow="6/7"
          textAlign="left"
          fontSize="1.3em"
          lineHeight="1.5em"
          paddingTop="0.1em"
          flexDirection="column"
        >
          <GradeResult>
            <Name>"{name}"</Name>님의 학력고사 등급은...
          </GradeResult>
          <GradeComment>{COUNT?.comment}</GradeComment>
        </GridGrade>
      </GradeContainer>
      <Stamp>
        <StampText>시놀교육과정평가원장</StampText>

        <StampImg src="/images/stamp.png" />
      </Stamp>
      <ResultBtns>
        {COUNT?.count === 5 ? (
          <ReplayOrReceiveBtn onClick={() => setModalShow(true)}>
            500원 포인트 받기
          </ReplayOrReceiveBtn>
        ) : (
          <ReplayOrReceiveBtn onClick={goMain}>
            <ReplayIcon fontSize="large" style={{ marginRight: "10px" }} />
            다시하기
          </ReplayOrReceiveBtn>
        )}

        {modalShow && (
          <ResultModal
            show={modalShow}
            onHide={() => setModalShow(false)}
            setmodalshow={setModalShow}
            setdownloadmodal={setDownloadModal}
            setpointmodal={setPointModal}
          />
        )}
        {downloadModal && (
          <EndModal
            content={SUCCESS}
            show={downloadModal}
            onHide={() => setDownloadModal(false)}
          />
        )}
        {pointModal && (
          <EndModal
            content={FAIL}
            show={pointModal}
            onHide={() => setPointModal(false)}
          />
        )}
        <CopyToClipboard text="https://event.sinor.co.kr/eventOldQuiz">
          <ShareBtn onClick={handleSnackbar}>
            <IosShareIcon fontSize="medium" style={{ marginRight: "10px" }} />
            이벤트 공유하기
          </ShareBtn>
        </CopyToClipboard>
        {openSnackbar && (
          <Snackbar
            autoHideDuration={2000}
            open={openSnackbar}
            onClose={handleSnackbar}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center",
            }}
          >
            <Alert
              severity="success"
              onClose={handleSnackbar}
              style={{
                backgroundColor: "#000000",
                color: "#ffffff",
              }}
            >
              복사되었습니다!
            </Alert>
          </Snackbar>
        )}
      </ResultBtns>
    </ResultContainer>
  );
};

export default Result;

const CLASSES = ["1", "2", "3", "4", "5"];

const TOTAL_RESULTS = [
  {
    count: 5,
    result: "수",
    comment: "축하합니다. 당신은 시놀 학력고사 최상위 1% 이십니다!",
  },
  {
    count: 4,
    result: "우",
    comment: "점수가 높으세요! 성적표를 친구분들께 자랑해보세요.",
  },
  {
    count: 3,
    result: "미",
    comment: "와우 마치 어제 일처럼 기억력이 좋으시네요.",
  },
  {
    count: 2,
    result: "양",
    comment: "이참에 잊어버린 추억을 다시 되짚어보아요~!",
  },
  {
    count: 1,
    result: "가",
    comment: "앗, 추억을 벌써 다 잊으신거 아니죠?",
  },
  {
    count: 0,
    result: "?",
    comment: "기억이 잘 안나는 날도 있죠. 다른 문제를 풀어보는건 어떨까요?",
  },
];

const SUCCESS = {
  mainTitle: null,
  subTitle: "시놀에 가입된 회원만 포인트 적립이 가능합니다",
  btnText: "앱 다운로드",
};

const FAIL = {
  mainTitle: "축하합니다",
  subTitle: "500원 포인트 지급 완료",
  btnText: "완료",
};

const ResultContainer = styled.div`
  width: 1000px;
  min-width: 200px;
  margin: 0 auto;
  margin-top: 3em;
  text-align: center;
  padding: 0 2em;

  @media screen and (max-width: 1000px) {
    width: 100vw;
  }
  @media screen and (max-width: 900px) {
    font-size: 14px;
  }
  @media screen and (max-width: 700px) {
    font-size: 12px;
  }
  @media screen and (max-width: 500px) {
    font-size: 10px;
  }
  @media screen and (max-width: 300px) {
    font-size: 8px;
  }
`;

const GradeContainer = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")};
  font-family: ${props => props.theme.style.yangjin};
  display: grid;
  width: 100%;
  height: 30em;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-template-rows: 2fr 1fr 1fr 1fr 2fr 2fr;
  outline: 5px solid black;

  @media screen and (max-width: 700px) {
    outline: 4px solid black;
  }

  @media screen and (max-width: 400px) {
    outline: 3px solid black;
  }
`;

const GridGrade = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")};
  outline: ${props => props.theme.style.border3};
  flex-direction: ${props => props.flexDirection};
  grid-column: ${props => props.gridColumn};
  grid-row: ${props => props.gridRow};
  padding-left: ${props => props.paddingLeft};
  color: ${props => props.color};
  text-align: ${props => props.textAlign};
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize};
  line-height: ${props => props.lineHeight};
  letter-spacing: ${props => props.letterSpacing};
  line-height: ${props => props.lineHeight};
  background-color: ${props => props.backgroundColor};
  position: relative;
  height: 100%;

  @media screen and (max-width: 700px) {
    outline: 2px solid black;
  }

  @media screen and (max-width: 400px) {
    outline: 1px solid black;
  }
`;

const CircleImg = styled(motion.img)`
  width: 50%;
`;

const TotalResult = styled(motion.div)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ff4a41;
  font-size: 1.2em;
  margin-top: 0.1em;
`;

const PlusOrMinus = styled(motion.div)`
  position: absolute;
  top: 10%;
  right: 15%;
  color: #ff4a41;
`;

const GradeResult = styled.div`
  color: ${props => props.theme.style.darkGrey};
  font-size: 0.8em;
  width: 100%;
  text-align: center;
`;

const Name = styled.strong`
  padding-right: 0.5em;
  font-size: 1.2em;
  text-decoration: underline;
  text-underline-offset: 0.3em;
`;

const GradeComment = styled.span`
  font-size: 1em;
  width: 100%;
  margin-left: 1em;
  text-align: center;
`;

const Stamp = styled.div`
  ${props => props.theme.variables.flex("", "center", "center")};
  margin-top: 3em;
`;

const StampText = styled.span`
  color: ${props => props.theme.style.darkGrey};
  margin-right: 0.5em;
  font-size: 1.8em;
  letter-spacing: 0.3em;
`;

const StampImg = styled.img`
  width: 5vw;
`;

const ResultBtns = styled.div`
  ${props => props.theme.variables.flex("column", "center", "center")};
  margin-bottom: 3em;

  .css-1vooibu-MuiSvgIcon-root {
    fill: #ffffff;
  }
`;

const ReplayOrReceiveBtn = styled.button`
  ${props => props.theme.variables.flex("", "center", "center")};
  color: ${props => props.theme.style.blue};
  border: 3px solid ${props => props.theme.style.blue};
  border-radius: 1em;
  width: 60%;
  height: 4em;
  min-width: 250px;
  margin-top: 2em;
  padding: 1em;
  text-decoration: none;
  font-size: 2em;
  outline: none;
  background-color: transparent;
`;

const ShareBtn = styled(ReplayOrReceiveBtn)`
  color: ${props => props.theme.style.white};
  background-color: ${props => props.theme.style.blue};
  margin-top: 1em;
  border: none;
`;
